export default __webpack_public_path__ + "assets/img_webp/zh-TW-logo.42846ce7.png";